import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog"
import { Button } from "@/components/ui/button"
import { ButtonVariant } from "@/constants/button/button"
import React from "react"

interface AlertDialogButtonProps {
  actionButtonText: string
  dialogTitle: string
  dialogSubtitle: string
  onClick: () => void
  variant: ButtonVariant
  actionButtonVariant?: ButtonVariant
  isTableActionButton: boolean
  isDisabled?: boolean,
  additionalClassName?: string
}

export const AlertDialogButton: React.FC<AlertDialogButtonProps> = ({
  actionButtonText,
  dialogTitle,
  dialogSubtitle,
  onClick,
  variant,
  actionButtonVariant,
  isTableActionButton,
  isDisabled,
  additionalClassName
}) => {

  const tableButton = () => {
    return (
      <button
        disabled={isDisabled ?? false}
        className={`text-accent font-medium underline mr-3 disabled:text-popover 
          disabled:cursor-not-allowed ${additionalClassName}`
        }
      >
        {actionButtonText}
      </button>
    )
  }

  const actionButton = () => {
    return (
      <Button
        type="button"
        className={`mb-2 font-semibold ${additionalClassName}`}
        variant={variant ?? ButtonVariant.LINK}
        disabled={isDisabled ?? false}
      >
        {actionButtonText}
      </Button>
    )
  }

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        {isTableActionButton ? tableButton() : actionButton()}
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{dialogTitle}</AlertDialogTitle>
          <AlertDialogDescription>
            {dialogSubtitle}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction variant={actionButtonVariant ?? variant} onClick={onClick}>
            {actionButtonText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
